import JobApplication from ".";
import TabsNavigation from "../../../../../components/elements/TabsNavigation";
import ApplicationDetails from "./ApplicationDetails";
const tabRoutes = [
  {
    label: "Applications",
    icon: "fa-regular fa-paper-plane",
    path: "/admin/job-applications",
  },
];

export const jobsApplicationRoutes = () => [
  {
    path: "/admin/job-applications",
    component: () => (
      <TabsNavigation title="Jobs Applications" tabRoutes={tabRoutes}>
        <JobApplication />
      </TabsNavigation>
    ),
    layout: "admin",
    routeType: "admin",
    title: "Jobs Applications",
  },
  {
    path: `/admin/application-view/:id`,
    component: ApplicationDetails,
    layout: "admin",
    routeType: "admin",
    title: "Application View",
  },
];
